import React, { useCallback, useMemo, useState } from "react";

import { Theme } from "2g-widget";
import { Icons } from "2g-icons";
import { useFetch } from "2g-hooks/fetch";
import { getFetcherForMethod } from "2g-utils-ajax";

import { DATA } from "b2b/api";
import useMessages from "./i18n/useMessages";
import getNejblizsiRezervaceProps from "b2b/components/rezervace-table/utils/getNejblizsiRezervaceProps";

export default function useRezervaceWidgetNejblizsi() {
  const { titleActionDownload } = useMessages();
  const fetch = useFetch();
  const props = getNejblizsiRezervaceProps();

  const [{ datumOd, datumDo }, setState] = useState({
    datumOd: props.datumOd,
    datumDo: props.datumDo
  });

  const onPeriodChange = useCallback((datumOd, datumDo) => {
    setState({ datumOd, datumDo });
  }, []);

  const handleDownload = useCallback(() => {
    fetch({
      url: DATA.zadostiExcel(),
      payload: {
        datumOd: datumOd.getTime(),
        datumDo: datumDo.getTime()
      },
      options: {
        headers: {
          Accept: "*/*"
        }
      },
      fetcher: getFetcherForMethod("post")
    });
  }, []);

  const headerActions = useMemo(
    () => [
      <Theme.HeaderAction key="readAll" onClick={handleDownload}>
        <Icons.Download />
        <span>{titleActionDownload()}</span>
      </Theme.HeaderAction>
    ],
    [handleDownload, titleActionDownload]
  );

  return { headerActions, ...props, datumOd, datumDo, onPeriodChange };
}
